import React, { Component, Fragment } from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import PropTypes from 'prop-types';
import { Card, CardBody } from 'reactstrap';
import { getFormValues, change } from 'redux-form';
import BasicsForm from 'components/forms/BasicsForm';
import PluginForm from 'components/forms/PluginForm';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as submissionFormActions from 'actions/submissionFormActions';
import * as appActions from 'actions/appActions';
import FormButtons from 'components/FormButtons';
import * as googlePlaceActions from 'actions/googlePlaceActions';
import * as formActions from 'actions/formActions';
import styles from './BasicsPage.scss';

class BasicsPage extends Component {
  static propTypes = {
    history: PropTypes.object.isRequired,
    formErrors: ImmutablePropTypes.map.isRequired,
    config: ImmutablePropTypes.map.isRequired,
    pricingTiers: ImmutablePropTypes.map.isRequired,
    currentUser: ImmutablePropTypes.map,
    submitForm: PropTypes.func.isRequired,
    categories: PropTypes.array.isRequired,
    timeZones: PropTypes.array.isRequired,
    saveDraft: PropTypes.func.isRequired,
    countries: PropTypes.object.isRequired,
    clearAddressErrors: PropTypes.func.isRequired,
    venue: PropTypes.object,
    showAppGlobalInfo: PropTypes.func.isRequired,
    hideAppGlobalInfo: PropTypes.func.isRequired,
    formValues: PropTypes.object,
    dispatch: PropTypes.func.isRequired,
    currencies: PropTypes.array.isRequired,
    loadPlaceDataFromPlaceId: PropTypes.func.isRequired,
    updateCountryDependencies: PropTypes.func.isRequired,
    updateZipDependencies: PropTypes.func.isRequired,
    showPlugin: PropTypes.bool.isRequired,
    category_id: PropTypes.number,
    title: PropTypes.string,
    online: PropTypes.bool,
  };

  componentDidMount() {
    if (this.props.config.get('premium_edit')) {
      this.props.showAppGlobalInfo('Make any necessary edits to your event');
    }
  }

  componentDidUpdate() {
    this.presetEndDate();
  }

  presetEndDate = () => {
    const { start_date, end_date, is_multiday } = this.props.formValues;
    if (is_multiday && start_date && start_date !== 'Invalid date' &&
      (!end_date || end_date === 'Invalid date' || start_date > end_date)) {
      this.props.dispatch(change('eventSubmission', 'end_date', start_date));
    }
  };

  submitForm = () => {
    this.form.submit();
  };

  formSubmitted = (data) => {
    this.props.submitForm('basics', this.props.history, data);
    if (this.props.config.get('premium_edit')) {
      this.props.hideAppGlobalInfo();
    }
  };

  saveDraft = () => this.props.saveDraft('basics');

  onClosePlugin = () => {
    this.props.dispatch(change('eventSubmission', 'show_plugin', false));
  };

  onSubmitPlugin = () => {
    const { venue, category_id, title, online } = this.props;
    if (this.pluginErrors().size) return;

    const ssParams = new URLSearchParams([
      ['form_data[title]', title],
      ['form_data[category_id]', category_id],
      ['form_data[venue][place_id]', venue.place_id],
      ['form_data[online]', online]
    ]);

    const snapSellUrl = location.origin + location.pathname +
      location.search.replace(/force_snap_sell/i, ssParams.toString());

    location.href = snapSellUrl;
  };

  pluginErrors = () => {
    const { venue, category_id, title, online } = this.props;

    let errors = new Map();
    if (!title) errors.set('title', 'Required');
    if (!category_id) errors.set('category_id', 'Required');
    if (!venue.place_id && !online) errors.set('venue', 'Required');

    return errors;
  };

  render() {
    const {
      pricingTiers, currentUser, categories, config, formErrors, countries,
      clearAddressErrors, loadPlaceDataFromPlaceId, showPlugin, eventbriteEnabled,
      updateCountryDependencies, updateZipDependencies, online, timeZones
    } = this.props;

    let showPluginModal = config.get('force_snap_sell');

    return (
      <div className={styles.basicContainer}>
        {showPluginModal && showPlugin && <div className="basic-layover">
          <Card className="plugin-modal">
            <PluginForm
              currentUser={currentUser}
              categories={categories}
              ref={ref => this.form = ref}
              onSubmit={this.onSubmitPlugin}
              config={config}
              formErrors={this.pluginErrors()}
              onVenueSelect={loadPlaceDataFromPlaceId}
              pricingTiers={pricingTiers}
              onClose={this.onClosePlugin}
            />
          </Card>
        </div>}
        <FormButtons top={true} previousVisible={false} onNext={this.submitForm} onSaveDraft={this.saveDraft} />
        <div className="row justify-content-center">
          <div className="col-md-10">
            <Card>
              <BasicsForm
                currentUser={currentUser}
                categories={categories}
                timeZones={timeZones}
                ref={ref => this.form = ref}
                onSubmit={this.formSubmitted}
                config={config}
                formErrors={formErrors}
                availableCountries={countries}
                onClearAddress={clearAddressErrors}
                onVenueSelect={loadPlaceDataFromPlaceId}
                onChangeCountry={updateCountryDependencies}
                onChangeZip={updateZipDependencies}
                pricingTiers={pricingTiers}
                online={online}
              />
            </Card>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  formValues: getFormValues('eventSubmission')(state),
  categories: state.categories,
  timeZones: state.timeZones,
  venue: state.form.eventSubmission.values.venue,
  category_id: state.form.eventSubmission.values.category_id,
  title: state.form.eventSubmission.values.title,
  online: state.form.eventSubmission.values.online,
  showPlugin: state.form.eventSubmission.values.show_plugin,
  formErrors: state.submissionForm.getIn(['steps', 'basics', 'errors']),
  currentUser: state.currentUser.get('data'),
  countries: state.countries.get('list'),
  eventbriteEnabled: state.config.get('eventbrite_enabled'),
  config: state.config,
  currencies: state.currencies,
  pricingTiers: state.pricingTiers,
});

const mapDispatchToProps = (dispatch) => ({
  dispatch,
  ...bindActionCreators(submissionFormActions, dispatch),
  ...bindActionCreators(appActions, dispatch),
  ...bindActionCreators(googlePlaceActions, dispatch),
  ...bindActionCreators(formActions, dispatch),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(BasicsPage);



// WEBPACK FOOTER //
// app/client/bundles/EventSubmission/containers/SubmissionSteps/BasicsPage.jsx